import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"
import { mapViewLayoutHandle } from "src/views/MapView/constants"
import { MapView } from "src/views/MapView/MapView"
import * as z from "zod"

const mapSearchSchema = z.object({
	asset: z.string().optional(),
	issue: z.string().optional(),
})

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/")({
	component: MapView,
	staticData: mapViewLayoutHandle,
	validateSearch: zodValidator(mapSearchSchema),
})
